'use strict';

function PermissionDirective (meService) {
  return {
    restrict: 'A',
    scope: {
      cnPermission: '='
    },

    link: function (scope, element) {
      var originalDisplay = element.css('display');
      element.css('display', 'none');
      if (!scope.cnPermission) {
        return;
      }
      postPermissionChange(undefined, meService.getPermissions());
      scope.$on('cenceo.permission.change', postPermissionChange);

      function postPermissionChange(event, permissions) {
        if (!permissions) {
          return;
        }

        if (permissions.some(function(group) { return group.name === scope.cnPermission; })) {
          element.css('display', originalDisplay);
        } else {
          element.remove();
        }
      }
    }
  };
}

module.exports = PermissionDirective;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/directives/permission/index.js
 ** module id = 24
 ** module chunks = 0
 **/